import { withPending, withRejected, withFulFilled } from './commons';
import {
  CREATE_SIMPLE_CROSS_CONFIG,
  UPDATE_SIMPLE_CROSS_CONFIG,
  LIST_SIMPLE_CROSS_CONFIG,
  FETCH_CROSS_CONFIG_RESULT,
  DELETE_CROSS_CONFIG_RESULT,
} from '../actions/simpleCross';

/**
 * Simple Factory
 * @returns Objeto de estado inicial do redux
 */
function getInitialState() {
  return {
    configuration: {
      running: false,
      error: null,
      payload: {}, // { id_configuracao: number }
      configs: {
        running: false,
        error: null,
        payload: [],
      },
    },
    result: {
      running: false,
      error: null,
      payload: {}, // os resultados sao um mapa que tem como chave eh `${idPesquisa}_${idPerguntaPrincipal}`
    },
  };
}

// initial state
const INITIAL_STATE = getInitialState();

/**
 * cria um novo estado respondendo à action
 * withPending(CREATE_SIMPLE_CROSS_CONFIG).
 *
 * Basicamente seta running = true
 */
function newConfigurationPending(state) {
  const newState = { ...state };
  newState.configuration.running = true;
  return newState;
}

/**
 * define qual problema ocorreu na configuracao
 * e set running como = false
 */
function newConfigurationRejected(state, action) {
  const error = action.payload;

  const newState = { ...state };
  newState.configuration.running = false;
  newState.configuration.error = error;
  return newState;
}

/**
 * Define o id da configuracao criada, running=false / error = null
 */
function newConfigurationFulfilled(state, action) {
  const newState = { ...state };
  newState.configuration.running = false;
  newState.configuration.error = null;
  newState.configuration.payload = action.payload;
  return newState;
}

/**
 * cria um novo estado respondendo à action
 * withPending(UPDATE_SIMPLE_CROSS_CONFIG).
 *
 * Basicamente seta running = true
 */
function updateConfigurationPending(state) {
  const newState = { ...state };
  newState.configuration.running = true;
  return newState;
}

/**
 * define qual problema ocorreu na configuracao
 * e set running como = false
 */
function updateConfigurationRejected(state, action) {
  const error = action.payload;

  const newState = { ...state };
  newState.configuration.running = false;
  newState.configuration.error = error;
  return newState;
}

/**
 * Define o id da configuracao criada, running=false / error = null
 */
function updateConfigurationFulfilled(state, action) {
  const newState = { ...state };
  newState.configuration.running = false;
  newState.configuration.error = null;
  newState.configuration.payload = action.payload;
  return newState;
}

/**
 * cria um novo estado respondendo à action
 * withPending(LIST_SIMPLE_CROSS_CONFIG).
 *
 * Basicamente seta running = true
 */
function listConfigurationsPending(state) {
  const newState = { ...state };
  newState.configuration.configs.running = true;
  return newState;
}

/**
 * define qual problema ocorreu na listagem
 * e set running como = false
 */
function listConfigurationsRejected(state, action) {
  const error = action.payload;

  const newState = { ...state };
  newState.configuration.configs.running = false;
  newState.configuration.configs.error = error.response;
  return newState;
}

/**
 * Define a listagem das configuracoes, running=false / error = null
 */
function listConfigurationsFulfilled(state, action) {
  const newState = { ...state };
  newState.configuration.configs.running = false;
  newState.configuration.configs.error = null;
  newState.configuration.configs.payload = action.payload;
  return newState;
}

/**
 * cria um novo estado respondendo à action
 * withPending(FETCH_CROSS_CONFIG_RESULT).
 *
 * Basicamente seta running = true
 */
function fetchConfigResultsPending(state) {
  const newState = { ...state };
  newState.result = {
    running: true,
    error: null,
    payload: {},
  };
  return newState;
}

/**
 * define qual problema ocorreu no fetch de resultados
 * e set running como = false
 */
function fetchConfigResultsRejected(state, action) {
  const error = action.payload;

  const newState = { ...state };
  newState.result.running = false;
  newState.result.error = error.response;
  return newState;
}

/**
 * Define os resultados da configuracaoSelecionada, running=false / error = null
 */
function fetchConfigResultsFulfilled(state, action) {
  const newResultPayload = { ...state.result.payload };
  const resultKey = `${action.meta.idPesquisa}_${action.meta.idPerguntaPrincipal}`;
  newResultPayload[resultKey] = action.payload.data;

  const newState = { ...state };
  newState.result.running = false;
  newState.result.error = null;
  newState.result.payload = newResultPayload;

  return newState;
}

/**
 * cria um novo estado respondendo à action
 * withPending(DELETE_CROSS_CONFIG_RESULT).
 *
 * Basicamente seta running = true
 */
function deleteConfigResultsPending(state) {
  const newState = { ...state };

  newState.result.running = true;
  newState.result.error = null;
  return newState;
}

/**
 * define qual problema ocorreu no fetch de resultados
 * e set running como = false
 */
function deleteConfigResultsRejected(state, action) {
  const error = action.payload;
  const newState = { ...state };

  newState.result.running = false;
  newState.result.error = error;

  return newState;
}

/**
 * Quando a ação de delete do cruzamento é completa, devemos resetar o payload dos resultados
 * e setar "running" = false e error = null.
 */ 
function deleteConfigResultsFulfilled(state, action) {
  const newState = getInitialState();

  return newState;
}

// executer
const execute = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  /**
   * Cadastro
   */
  case withPending(CREATE_SIMPLE_CROSS_CONFIG):
    return newConfigurationPending(state);
  case withRejected(CREATE_SIMPLE_CROSS_CONFIG):
    return newConfigurationRejected(state, action);
  case withFulFilled(CREATE_SIMPLE_CROSS_CONFIG):
    return newConfigurationFulfilled(state, action);

  /**
   * Atualização
   */
  case withPending(UPDATE_SIMPLE_CROSS_CONFIG):
    return updateConfigurationPending(state);
  case withRejected(UPDATE_SIMPLE_CROSS_CONFIG):
    return updateConfigurationRejected(state, action);
  case withFulFilled(UPDATE_SIMPLE_CROSS_CONFIG):
    return updateConfigurationFulfilled(state, action);

  /**
   * Listagem
   */
  case withPending(LIST_SIMPLE_CROSS_CONFIG):
    return listConfigurationsPending(state);
  case withRejected(LIST_SIMPLE_CROSS_CONFIG):
    return listConfigurationsRejected(state, action);
  case withFulFilled(LIST_SIMPLE_CROSS_CONFIG):
    return listConfigurationsFulfilled(state, action);
  /**
   * Resultados
   */
  case withPending(FETCH_CROSS_CONFIG_RESULT):
    return fetchConfigResultsPending(state);
  case withRejected(FETCH_CROSS_CONFIG_RESULT):
    return fetchConfigResultsRejected(state, action);
  case withFulFilled(FETCH_CROSS_CONFIG_RESULT):
    return fetchConfigResultsFulfilled(state, action);
  /**
   * Delete
   */
  case withPending(DELETE_CROSS_CONFIG_RESULT):
    return deleteConfigResultsPending(state);
  case withRejected(DELETE_CROSS_CONFIG_RESULT):
    return deleteConfigResultsRejected(state, action);
  case withFulFilled(DELETE_CROSS_CONFIG_RESULT):
    return deleteConfigResultsFulfilled(state, action);

  default:
    return state;
  }
};

export default execute;
